import { ModuleBase } from '@/presentation/configuration/modules/ModuleBase'
import { DashboardRepository } from '@/core/infrastructure/repositories/dashboard/DashboardRepository'
import { FetchDashboardClassroomScoreModuleResultsUseCase } from '@/core/useCases/dashboard/FetchDashboardClassroomScoreModuleResultsUseCase.ts'
import { FetchDashboardClassroomScoreDiagnosticResultsUseCase } from '@/core/useCases/dashboard/FetchDashboardClassroomScoreDiagnosticResultsUseCase.ts'
import { CreateDashboardClassroomDiagnosticTriggerUseCase } from '@/core/useCases/dashboard/CreateDashboardClassroomDiagnosticTriggerUseCase.ts'
import { FetchAllDashboardClassroomDiagnosticTriggerUseCase } from '@/core/useCases/dashboard/FetchAllDashboardClassroomDiagnosticTriggerUseCase.ts'
import { FetchClassroomDiagnosticsUseCase } from '@/core/useCases/dashboard/FetchClassroomDiagnosticsUseCase.ts'
import { PublishClassroomDiagnosticUseCase } from '@/core/useCases/dashboard/PublishClassroomDiagnosticUseCase.ts'
import { FetchClassroomDiagnosticStateUseCase } from '@/core/useCases/dashboard/FetchClassroomDiagnosticStateUseCase.ts'
import { TriggerDiagnosticStartUseCase } from '@/core/useCases/dashboard/TriggerDiagnosticStartUseCase.ts'
import { TriggerDiagnosticEndUseCase } from '@/core/useCases/dashboard/TriggerDiagnosticEndUseCase.ts'
import { FetchClassroomDiagnosticResultsUseCase } from '@/core/useCases/dashboard/FetchClassroomDiagnosticResultsUseCase.ts'
import { FetchClassroomModuleResultsUseCase } from '@/core/useCases/dashboard/FetchClassroomModuleResultsUseCase.ts'

export class DashboardModule extends ModuleBase {
  initialize() {
    this.initializeDashboard()
  }

  private initializeDashboard(): void {
    const dashboardRepository = new DashboardRepository()
    this.registerRepository(DashboardRepository, dashboardRepository)

    const fetchDashboardClassroomScoreModuleResults =
      new FetchDashboardClassroomScoreModuleResultsUseCase(dashboardRepository)
    const fetchDashboardClassroomScoreDiagnosticResults =
      new FetchDashboardClassroomScoreDiagnosticResultsUseCase(dashboardRepository)
    const fetchAllDashboardClassroomDiagnosticTriggers =
      new FetchAllDashboardClassroomDiagnosticTriggerUseCase(dashboardRepository)
    const createDashboardClassroomDiagnosticTrigger =
      new CreateDashboardClassroomDiagnosticTriggerUseCase(dashboardRepository)
    const fetchClassroomDiagnostics = new FetchClassroomDiagnosticsUseCase(dashboardRepository)
    const publishClassroomDiagnostic = new PublishClassroomDiagnosticUseCase(dashboardRepository)
    const fetchClassroomDiagnosticState = new FetchClassroomDiagnosticStateUseCase(
      dashboardRepository
    )
    const triggerDiagnosticStart = new TriggerDiagnosticStartUseCase(dashboardRepository)
    const triggerDiagnosticEnd = new TriggerDiagnosticEndUseCase(dashboardRepository)
    const fetchClassroomDiagnosticResults = new FetchClassroomDiagnosticResultsUseCase(
      dashboardRepository
    )
    const fetchClassroomModuleResults = new FetchClassroomModuleResultsUseCase(dashboardRepository)

    this.registerUseCase(
      FetchDashboardClassroomScoreModuleResultsUseCase,
      fetchDashboardClassroomScoreModuleResults
    )
    this.registerUseCase(
      FetchDashboardClassroomScoreDiagnosticResultsUseCase,
      fetchDashboardClassroomScoreDiagnosticResults
    )
    this.registerUseCase(
      FetchAllDashboardClassroomDiagnosticTriggerUseCase,
      fetchAllDashboardClassroomDiagnosticTriggers
    )
    this.registerUseCase(
      CreateDashboardClassroomDiagnosticTriggerUseCase,
      createDashboardClassroomDiagnosticTrigger
    )
    this.registerUseCase(FetchClassroomDiagnosticsUseCase, fetchClassroomDiagnostics)
    this.registerUseCase(PublishClassroomDiagnosticUseCase, publishClassroomDiagnostic)
    this.registerUseCase(FetchClassroomDiagnosticStateUseCase, fetchClassroomDiagnosticState)
    this.registerUseCase(TriggerDiagnosticStartUseCase, triggerDiagnosticStart)
    this.registerUseCase(TriggerDiagnosticEndUseCase, triggerDiagnosticEnd)
    this.registerUseCase(FetchClassroomDiagnosticResultsUseCase, fetchClassroomDiagnosticResults)
    this.registerUseCase(FetchClassroomModuleResultsUseCase, fetchClassroomModuleResults)
  }
}
